export default __webpack_public_path__ + "media/ClinicalOralHeroImageMobile.aeb145a2bfb4bf16f6e8bf1b3f6a1c26.webp";